export default "__VITE_ASSET__f59905cb__"